<template>
  <div>
    <div class="card leftcard">
      <div class="card-header">
      <h4 class="card-title subject">
        RunsResult
      </h4>
      <div class="righter twitter_share">
        <a @click="twitterShare" title="Twitter" class="share btn btn-twitter btn-sm"><i class="fa fa-twitter fa-fw"></i>
        <img src="../assets/Twitter_Logo_WhiteOnImage.svg" width="20" height="20">Twitterでシェア</a>
      </div>
      </div>
      <div class="card-body">
        <ul class="container-fluid">
          <div class="row">
            <div class="col-auto">
              <b class="headline">得点データ</b>
              <vue-good-table
                :columns="sr_columns"
                :rows="this.result_sim.scores_data"
                max-height="600px" class="table_row"
                :sort-options="{enabled: false,}">
                
              </vue-good-table>
              <!--
              <a class="link" @click="downloadCSV">CSVでダウンロード <img src="../assets/download.svg" width="16" height="16"></a></div>
                <b-dropdown right
                text="CSV形式でダウンロード" variant="outline-info"
                style="margin:-8px 0px -8px 0px; height:36px;" boundary='window' >
                  <b-dropdown-item v-for="(type, index) in ['socres', 'gamelog']" :key="'csvdl' + index"
                  @click="downloadCSV(type)"
                  variant="info" style="position: relative;overflow: visible;"
                  >
                  <span v-if="type=='socres'">全試合スコア</span>
                  <span v-else-if="type=='gamelog'">試合ログ</span>
                  </b-dropdown-item>
                </b-dropdown>
              -->
              <div class="righter">
                <a class="link" @click="downloadCSV('scores')">CSVでダウンロード <img src="../assets/download.svg" width="16" height="16"></a></div>

              </div>
              <div class="row col-auto">
                <div class="col-auto">
                    
                <b class="headline">試合得点分布</b>
                <histgram :chartData="this.result_sim.chart_data['all']" :type="'all'" :height="360"></histgram>
              </div>
              <!--:width="300" :height="300"でサイズ変える-->
              <div class="col-auto">
                <b class="headline">年間得点分布</b>
                <histgram :chartData="this.result_sim.chart_data['nen']" :type="'nen'" :height="360"></histgram>
              </div>
            </div>
          </div>
        </ul>
      </div>
    </div>
    <div class="card rightcard">
      <div class="card-header">
      <h4 class="card-title subject">
        OtherStats
      </h4>
      </div>
      <ul class="nav nav-pills info" style="padding:0px 1%;">
        <li class="nav-item" v-for="(item, index) in OtherTabs" :key="index">
          <a v-on:click="OtherTabSelect(item)" class="nav-link" v-bind:class="{'active': OtherStatsTab === item}">{{item}}</a>
        </li>
      </ul>
      <div style="border-top: 1px solid #DDD;"></div>
      <div class="card-body">
        <div v-if="OtherStatsTab == '打撃成績'">
          <div class="subject headline">打順別打撃成績 /年</div>
            <div class="righter custom-control custom-switch">
              <input type="checkbox" class="custom-control-input" id="detailswitch"
              v-model="ToggleFlag[OtherStatsTab]"
              value="ToggleFlag[OtherStatsTab]">
              <label class="custom-control-label" for="detailswitch">詳細</label>
            </div>
          <vue-good-table v-if="OtherStatsTab == '打撃成績'" :value="true"
          :columns="st_columns"
          :rows="PrintSimResult"
          :sort-options="{enabled: false,}" class="table_row">
          >
          </vue-good-table>
        </div>
        <div v-if="OtherStatsTab == '得点期待値' || OtherStatsTab == '得点確率' || OtherStatsTab == '発生割合'">
          <div class="subject headline">{{TabLabel}}</div>
          <div class="righter custom-control custom-switch">
            <button type="button" class="btn btn-outline-info px-1 py-1"
            @click="$refs.myCustomTable.expandAll();"
            >OPEN</button>
            <button type="button" class="btn btn-outline-info px-1 py-1"
            @click="$refs.myCustomTable.collapseAll();"
            >CLOSE</button>
          </div>
          <vue-good-table :value="true"
            ref="myCustomTable"
            :columns="RE_runners(OtherStatsTab != '得点確率')"
            :rows="OccuRows"
            :sort-options="{enabled: false,}" class="table_row"
            :groupOptions="{
              enabled: true,
              collapsable: 1,
            }"
            >
          </vue-good-table>
        </div>
        <div  v-if="OtherStatsTab == 'イベント別'">
          <div class="subject headline">イベント別得点期待値</div>
          <div class="righter custom-control custom-switch">
            <input type="checkbox" class="custom-control-input" id="detailswitch"
            v-model="ToggleFlag[OtherStatsTab]" value="ToggleFlag[OtherStatsTab]">
            <label class="custom-control-label" for="detailswitch">打順補正</label>
          </div>
        </div>
        <vue-good-table v-if="OtherStatsTab == 'イベント別'" :value="false"
          :columns="RE_events"
          :rows="EvEx_Rows(true)"
          :sort-options="{enabled: false,}" class="table_row">
        </vue-good-table>
        <div  v-if="OtherStatsTab == 'イベント別'">
          <div class="subject headline">イベント別得点確率</div>
          <vue-good-table v-if="OtherStatsTab == 'イベント別'" :value="false"
            :columns="RE_events"
            :rows="EvEx_Rows(false)"
            :sort-options="{enabled: false,}" class="table_row">
          </vue-good-table>
        </div>
      </div>
      {{OpenFirst}}
    </div>

  </div>
</template>

<script>
import Mixin from '../mixins/utility'
import { mapState } from 'vuex'

import histgram from './histgram.vue'

export default {
  name: 'index',
  components: {
      histgram
  },
  data() {
    return {
      ToggleFlag: {'打撃成績': false, '得点期待値': false, '得点確率': false, '発生割合': false, 'イベント別': true },
      OtherStatsTab: '打撃成績',
      runnerList: ['000', '100', '010', '001', '110', '101', '011','111'],
      sr_columns: [
        /*{
          label: '',
          field: 'name',
          type: 'text',
        },
        {
          label: '試合',
          field: '試合',
          type: 'number',
        },
        {
          label: '年',
          field: '年',
          type: 'number',
        },*/
        {
          label: '単位',
          field: 'name',
        },
        {
          label: '平均点',
          field: '平均点',
        },
        {
          label: '最頻値',
          field: '最頻値',
        },
        {
          label: '中央値',
          field: '中央値',
        },
        {
          label: '標準偏差',
          field: '標準偏差',
        },
      ],
      simresult: {},
      scorelist: [],
      last_tab: '',
    }
  },
  mixins: [Mixin],
  computed: {
    TabLabel () {
      return this.OtherStatsTab == 'イベント別' ? 'イベント別得点期待値' : this.OtherStatsTab
    },
    OtherTabs () {
      let tabs = ['打撃成績', '得点期待値', '得点確率', '発生割合', 'イベント別']
      if(this.result_sim.calc_flag != true)tabs.splice(1, tabs.length - 1);
      if(tabs.indexOf(this.OtherStatsTab) == -1)this.OtherTabSelect ('打撃成績')
      
      return tabs
    },
    Row_jun () {
      return ['ALL'].concat(Array.from(Array(9).keys()))
    },
    RE_events () {
      let relist = [{field: 'name', label: '打順', type: 'text'}]
      this.EventsList.some(event => {
        relist.push({field: event, label: this.RecordName(event), type: 'number'})
      })
      //relist.push({field: 'RE24', label: 'RE24/年'})
      return relist;
    },
    RE_runners () {
      return function () {
      let relist = [{field: 'out', label: 'Out', type: 'text'}]
      this.runnerList.some(runner => {
        //, type: 'percentage'
        relist.push({field: runner, label: this.StrRunner(runner),
        type: 'number'})
      })
      return relist;
      }
    },
    st_columns () {
      let clm = []
      // rlist.push('AVG')
      this.SRList(this.ToggleFlag['打撃成績']).some(r =>{
        let c = {
          label: this.RecordName(r), field: r,
          type: (r == 'name' ? 'text' : 'number'),
        }
        clm.push(c)
      })
      return clm
    },
    SRList () {
      return function(mode) {
        const shflag = this.SH_flag
        function FullRecordList (l) {
          let list = l.slice()
          if(shflag)list.push('SH')
          return list
        }
        let rlist = {
          0: ['name', 'AB', 'H', 'HR', 'RBI', 'AVG', 'OBP', 'SLG', 'OPS'],
          1: FullRecordList(this.FilterRecordList)
        }
        return rlist[Number(mode)]
      }
    },
    OccuRowsKey () {
      return this.OtherStatsTab == '得点期待値' ? 'Expected' :
      this.OtherStatsTab == '得点確率' ? 'Probability' :
      this.OtherStatsTab == '発生割合' ? 'Occurrence' :
      ''
    },
    OccuRows (){
      const key = this.OccuRowsKey
      let oclist = []
      //Array.from(Array(9).keys()).some(jun => {
      this.Row_jun.some(jun => {
        let row =   {
          mode: "span", // span means this header will span all columns
          label: (jun == 'ALL' ? jun : (jun + 1) + "番"),
          html: false, // if this is true, label will be rendered as html
          children: this.RE_Rows(key, jun)
        }
        oclist.push(row)
      })
    return oclist;
      //
    },
    RE_Rows () {
      return function (type, jun) {
        let list = []
        const re = this.result_sim.re_result
        
        let junlist = Array.from(Array(3).keys());
        junlist.some(out => {
          let reobj = {out: out}
          this.runnerList.some(r => {
            reobj[r] = re[type][jun][out.toString() + ' ' + r]
            if(type == 'Expected')
            reobj[r] = (isFinite(reobj[r]) == false ? '-' : reobj[r].toFixed(3))
            else
            reobj[r] = (isFinite(reobj[r]) == false ? '-%' : Number(reobj[r] * 100).toFixed(2) + '%')
          })
          list.push(reobj)
        })
        return list
      }
    },
    EvEx_Rows () {
      return function (expr){
        const evex_key = (expr?'event_exp':'event_pro')
        let junlist = this.Row_jun;
        let exlist = []
        
        const AllPA = this.result_sim.player_total[4].PA
        junlist.some(jun => {
          const j = jun.toString()
          let exobj = {name: (jun == 'ALL' ? 'ALL' : (jun + 1) + '番')}
          this.RE_events.some(c => {
            if(c.field == 'RE24'){
              let evre = 0
              this.EventsList.some(event => {
                evre += this.result_sim[evex_key][jun][event] *
                this.result_sim.player_total[jun][event]
              })
              exobj[c.field] = (evre / this.result_sim.yearlen).toFixed(2)
              exlist.push(exobj)
            }else
            if(c.field != 'name')
            if(isNaN(this.result_sim[evex_key][j][c.field])){
              exobj[c.field]='-'
            }else{
              exobj[c.field] = this.result_sim[evex_key][j][c.field]
              if(expr == 0) {
                exobj[c.field] = (exobj[c.field] * 100).toFixed(2) + '%'
              }else{
                exobj[c.field] = (exobj[c.field] * (jun === 'ALL' || this.ToggleFlag[this.OtherStatsTab] == false ? 1.00 : this.calcWari(this.result_sim.player_total[jun].PA, AllPA)))
                .toFixed(3)
              }
            }
          })
          exlist.push(exobj)
        })
        return exlist
      }

    },
    PrintSimResult () {
      let list = []
      const nen = this.result_sim.scores.length,
      juns = ['ALL'].concat(Array.from(Array(9).keys()))
      juns.some(jun => {
        const j = jun.toString()
        let prec = {}, p = this.result_sim.player_total[j]
        this.SRList(1).some(r => {
          prec[r] = this.calcRecord(r, p)
          if(r == 'name') {
            if(j == 'ALL')prec[r] = j;
            else
            prec[r] = (jun + 1) + ':' + p.name// + '番'
          }else if(r == 'AVG' || r == 'OBP' || r == 'SLG' || r == 'OPS'){
            prec[r] = this.printAVG(prec[r], 3)
          }else{
            prec[r] = Math.round(this.calcWari(prec[r], nen))
          }
        })
        list.push(prec)
      })
      return list;
    },
    OpenFirst() {
      if (this.$refs.myCustomTable)this.$refs.myCustomTable.expandAll();
      //toggleExpand(index)
    },
  },
  methods: {
    downloadCSV (type) {
      var csv = '\ufeff', filename = ''
      if (type == "scores") {
        filename = 'scores_result.csv'
        csv += '年,'
        this.result_sim.scores.some((nenscore, nindex) => {
          let line = ''
          nenscore.some((sc, gindex) => {
            if(nindex == 0) {
              csv += (gindex + 1) + ','
            }
            line += sc + ','
          })
          csv += '\n' + (nindex + 1) + ',' + line
        })
      }else{
        filename = 'gamelog_result.csv'
        const items = this.result_sim.gamelogs
        csv = '打順,回,死,1塁,2塁,3塁,イベント,点,\n'
        items.forEach((el, index) => {
          const run = (index == 0 ? '0 000':items[index-1]['runner'])
          const jokyo = run.split(' '),r = Number(jokyo[1]),
          out = (jokyo[0] == 3 ? 0 : jokyo[0])
          const runner = [r >= 100, r%100 >= 10, r % 10 >= 1]
          var line = (el['jun'] + 1) + ',' + el['ining'] + ',' 
          + out + ',' + runner[0] + ',' + runner[1] + ',' + runner[2] + ','
          + this.RecordName(el['result']) + ',' + el['score'] + '\n'
          csv += line
        })
      }

      let blob = new Blob([csv], { type: 'text/csv' })
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = filename
      link.click()
    },
    twitterShare(){
        //シェアする画面を設定
        let batterlist = ""
        Object.values(this.result_sim.player_total).some((p, jun) => {
          if(jun<9)batterlist += (jun+1) + ":" + p.name + "%0a"
        })
        
        var shareURL = 'https://twitter.com/intent/tweet?text='
        + batterlist + "の打線で" + 
        "1試合あたり" + this.result_sim.scores_data[0]["平均点"] + "点、" +
        "年間" + this.result_sim.scores_data[1]["平均点"] + "点取れます%0a" + '&url=' + location.href;  
        //シェア用の画面へ移行
        window.open(shareURL, '_blank', "width=400, height=300, menubar=no, toolbar=no, scrollbars=yes");　//←★ここ
        //location.href = shareURL
    },
    OtherTabSelect (num) {
      this.OtherStatsTab = num
      //this.ToggleFlag[this.OtherStatsTab] = true;
    },
  },
}
</script>

<style scoped>
.row {
  /*border: solid #008080;*/
}
svg {
  fill: currentColor;
}
.link {
  color: #2d918d;text-decoration : underline;
}
.nav-item {
  color: #2d918d;
  position: relative;
}
.nav-pills .nav-link.active, .nav-pills .show > .nav-link {
  color: #fff;
  background-color: #17a3b8;
  border-radius: 6px 6px 6px 6px;
}
.nav-item:hover {
  border-color: #17a3b8;
  outline: 2px solid;
  outline-offset: -2px;
  border-radius: 6px 6px 6px 6px;
  box-shadow: 2px 2px 4px inset;
 }

.container-fluid, .container-sm, .container-md, .container-lg, .container-xl {
  width: 100%;
  padding-right: 1px;
  padding-left: 1px;
  margin-right: 1px;
  margin-left: 1px; }
.btn-twitter {
  background: #00ACEE;
  border-radius: 0;
  color: #fff;
  border-width: 1px;
  border-style: solid;
  border-color: #0075a2;
}
.btn-twitter:link, .btn-twitter:visited {
  color: #fff; 
}
.btn-twitter:active, .btn-twitter:hover {
  background: #0075a2;
  color: #fff; 
}

</style>



// WEBPACK FOOTER //
// src/components/simscreen.vue